import React, { useMemo } from 'react'
import { Flex, Text } from '@chakra-ui/react'
import { CardFilePreview } from '../../UI'
import store from '../../../store'

const RenderDocument = ({ titleDocument, arrayDocuments }) => {
  const sortedDocuments = useMemo(
    () =>
      [...arrayDocuments].sort((a, b) => new Date(a.date) - new Date(b.date)),
    [arrayDocuments]
  )

  const generateColor = (index, total) => {
    const brightness = 100 - (index / total) * 50 // Adjust the range as needed

    console.log(index, total, brightness)

    return `hsl(120, 100%, ${brightness}%)`
  }

  const { order: orderSelected } = store.getState()


  const isHighlighted = (item) => orderSelected.order === item

  return (
    <Flex gap={4} direction={'column'}>
      <Text fontWeight={700}>{titleDocument}</Text>
      {sortedDocuments?.map((item, index) => (
        <CardFilePreview
          key={index}
          name={item?.name}
          url={item?.url}
          highlightColor={
            isHighlighted(item?.newName)
              ? '#80ff80'
              : 'white'
          }
        />
      ))}
    </Flex>
  )
}

export default RenderDocument
